import { render, staticRenderFns } from "./JsaEmployeeList.vue?vue&type=template&id=06d97bc6"
import script from "./JsaEmployeeList.vue?vue&type=script&lang=js"
export * from "./JsaEmployeeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports